<template>
  <div>
    <popup title="Редактирование прибора учета" :active.sync="active" class="edit-popup">
      <div class="edit-popup__content">
        <div class="edit-popup__info" :class="{'edit-popup__info_no-border': !$can('rp.acts', 'read')}">
          <div class="edit-popup__header edit-popup__header_center device-info-header">
            <feather-icon
              v-if="$store.getters['common/devices/typeById'](device.type).icon"
              class="device-info-header__icon"
              :class="[
                            $store.getters['common/devices/typeById'](device.type).icon_color ? 'text-' + $store.getters['common/devices/typeById'](device.type).icon_color : ''
                            ]"
              :icon="$store.getters['common/devices/typeById'](device.type).icon"
            />
            <div class="device-info-header__text-info">
              {{ $store.getters['common/devices/typeById'](device.type).name }}
              <span>({{ device.factory_number ? device.factory_number : 'Без номера' }})</span>
            </div>

          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Название</label>
            <vs-input class="edit-popup__form-control edit-popup__form-control_input" v-model="device.device_name" />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Номер</label>
            <vs-input class="edit-popup__form-control edit-popup__form-control_input" v-model="device.factory_number" />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Дата начала эксплуатации</label>
            <datepicker
              class="edit-popup__form-control edit-popup__form-control_datepicker"
              format="dd.MM.yyyy"
              v-model="device.operation_start_date"
              disabled
            />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Дата следующей поверки</label>
            <datepicker
              class="edit-popup__form-control edit-popup__form-control_datepicker"
              format="dd.MM.yyyy"
              v-model="device.next_checking_date"
              inBody
              typeable
            />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Начальное показание</label>
            <vs-input
              class="edit-popup__form-control edit-popup__form-control_input"
              :value="device.start_value"
              disabled
            />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">Комментарий</label>
            <vs-textarea
              class="edit-popup__form-control edit-popup__form-control_input edit-popup__textarea"
              v-model="device.comment"
            />
          </div>
          <div class="edit-popup__row">
            <label class="edit-popup__label">ГИС идентификатор</label>
            <vs-input
              class="edit-popup__form-control edit-popup__form-control_input"
              :value="device.number_in_gis"
              disabled
            />
          </div>
          <vs-button type="border" size="medium" @click="saveAct" class="vs-button_square w-full" color="success">
            Сохранить
          </vs-button>
          <vs-button
            v-if="canRemoveDevice"
            type="border"
            size="medium"
            @click="showDialog"
            class="vs-button_square w-full mt-4"
            color="danger"
          >Удалить
          </vs-button>

          <div class="mt-4" v-if="canToggleActionState">
            <vs-button
              v-if="this.device.actual_state === 7"
              type="border"
              size="small"
              @click="onEnable"
              class="w-full"
              color="success"
            >
              Включить
            </vs-button>
            <vs-button
              v-else
              type="border"
              size="small"
              @click="onDisable"
              class="w-full"
              color="danger"
            >
              Отключить
            </vs-button>

          </div>
        </div>

        <div class="edit-popup__acts" v-if="$can('rp.acts', 'read')">
          <div class="edit-popup__header">
            АКТЫ
            <div class="ml-auto">
              <vs-button
                type="border"
                size="medium"
                @click="openNewAct"
                v-if="$can('rp.acts.create', 'write')"
                class="vs-button_square"
              >Добавить новый
              </vs-button>
            </div>
          </div>

          <div class="scroll-table">
            <div class="scroll-table__wrapper">
              <vs-table :data="acts" class="acts-table" no-data-text="Актов нет">
                <template slot="thead">
                  <vs-th>№</vs-th>
                  <vs-th>Дата добавления</vs-th>
                  <vs-th>Тип акта</vs-th>
                  <vs-th>Статус</vs-th>
                  <vs-th />
                </template>

                <template slot-scope="{data}" ref="content">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>
                      <div class="flex items-center acts-table__value">
                        <feather-icon icon="ClockIcon" class="acts-table__icon" />
                        {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="flex items-center acts-table__value">
                        <feather-icon icon="FileTextIcon" class="acts-table__icon" />
                        <div>
                          <dictionary-item :dictionary="actTypes" :id="tr.act_type" />
                        </div>
                      </div>

                    </vs-td>
                    <vs-td>
                      <act-status :id="tr.status" />
                    </vs-td>
                    <vs-td>
                      <a href="#" @click.prevent="openActChange(tr.id)">
                        <feather-icon :icon="$can('rp.acts.update', 'write') ? 'PenIcon' : 'EyeIcon'" />
                      </a>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </popup>
    <act-popup-change ref="actChange" @update-act="getActs(device.id)" />
    <act-popup-new ref="actNew" @created="getActs(device.id)" />

    <confirm-words-popup ref="confirmPopup" @accept="deleteDevice" />

  </div>
</template>

<script>
import Popup             from "@/components/popup/Popup";
import ActPopupChange    from "@/components/calculated-program/acts/ActPopupChange";
import ActPopupNew       from "@/components/calculated-program/acts/ActPopupNew";
import DictionaryItem    from "@/components/DictionaryItem";
import actTypes          from "@/dictionaries/actTypes";
import ActStatus         from "@/components/ActStatus";
import { DEVICE_TYPES }  from "@/client/constants";
import ConfirmWordsPopup from "../ConfirmWordsPopup";

export default {
  name:       "DeviceEditPopup",
  components: { ActStatus, DictionaryItem, Popup, ActPopupChange, ActPopupNew, ConfirmWordsPopup },
  props:      {},
  data() {
    return {
      active: false,
      device: null,
      acts:   [],
      actTypes,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    canRemoveDevice() {
      const { type } = this.device;
      if ([DEVICE_TYPES['ээ1'], DEVICE_TYPES['ээ2'], DEVICE_TYPES['ээ3']].includes(type)) return this.$can('support', 'write');
      return true;
    },

    canToggleActionState() {
      return this.$can('support', 'write');
      // return this.$can('support', 'write') && ![3, 4, 5].includes(this.device.actual_state);
    },
  },
  methods:  {
    resetDevice() {
      this.device = {
        id:                 null,
        type:               null,
        factory_number:     null,
        device_name:        null,
        next_checking_date: null,
        comment:            null,
      };
      this.acts = [];
    },
    async open( id ) {
      try {
        this.resetDevice();
        let { data: device } = await this.$http.get('devices', {
          params: {
            buildings_id: this.selectedHouseId,
            id:           id,
          },
        });

        this.device = device.length ? device[0] : {};
        this.device.next_checking_date = this.device.next_checking_date === null ? null : this.$parseDateFromString(this.device.next_checking_date);
        this.device.operation_start_date = this.device.operation_start_date === null ? null : this.$parseDateFromString(this.device.operation_start_date);
        await this.getActs(id);

        this.$nextTick(() => {
          this.active = true;
        });
      } catch (e) {
        console.error(e);
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    getActs( id ) {
      return new Promise(async resolve => {
        if (!this.$can('rp.acts', 'read')) resolve([]);

        try {
          let { data } = await this.$http.get('devices_acts', {
            params: {
              buildings_id: this.selectedHouseId,
              devices_id:   id,
            },
          });
          this.acts = data;
          resolve(data);
        } catch (e) {
          resolve([]);
        }
      });
    },
    openNewAct() {
      this.$refs.actNew.openWithEntity('device', this.device);
    },
    openActChange( id ) {
      this.$refs.actChange.open(id);
    },
    async saveAct() {
      try {
        let body = {
          device_name:        this.device.device_name,
          factory_number:     this.device.factory_number,
          id:                 this.device.id,
          next_checking_date: this.device.next_checking_date === null ? null : this.$options.filters.moment(this.device.next_checking_date, 'YYYY-MM-DD'),
          buildings_id:       this.selectedHouseId,
          comment:            this.device.comment,
        };

        let { data } = await this.$http.put('devices/' + body.id, body);
        this.$vs.notify({ color: 'success', title: 'Успешное изменение', text: 'Прибор изменен' });
        this.active = false;
        this.$emit('updated', data);
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    async deleteDevice() {
      try {
        await this.$http.delete('devices/' + this.device.id, { params: { buildings_id: this.selectedHouseId } });

        this.active = false;
        this.$emit('deleted');

        this.$vs.notify({ color: 'success', title: 'Успешное удаление', text: 'Прибор учета удален' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    showDialog() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     async () => {
          this.$refs.confirmPopup.open();
        },
      });
    },

    onDisable() {
      this.$modal.open({
        size:           'xs',
        title:          'Отчключение счетчика',
        component:      () => import('@/components/calculated-program/metering/DeviceToggleStatePopup'),
        componentProps: {
          device: this.device,
        },
      }).result.then(() => {
        this.open(this.device.id);
        this.$emit('updated');
      });
    },

    onEnable() {
      this.$modal.open({
        size:           'xs',
        title:          'Включение счетчика',
        component:      () => import('@/components/calculated-program/metering/DeviceToggleStatePopup'),
        componentProps: {
          device: this.device,
        },
      }).result.then(() => {
        this.open(this.device.id);
        this.$emit('updated');
      });
    },
  },
  created() {
    this.resetDevice();
  },
};
</script>

<style lang="scss">
.edit-popup {
  &__header {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    margin-bottom: 15px;
    font-weight: 500;

    &_center {
      justify-content: center;
    }
  }

  &__label {
    padding-right: 15px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
    flex: 1;
    margin-bottom: 5px;
    display: block;
    line-height: 1.2;
  }

  &__form-control {
    margin-bottom: 15px;

    &_input {
      &.vs-input {
        width: 100%;
      }

      .vs-input--input {
        padding: .5rem;
        border-radius: 2px;
      }
    }

    &_datepicker {
      input {
        width: 100%;
        padding: .5rem;
        border-radius: 2px;
      }
    }
  }

  &__content {
    display: flex;
  }

  &__info {
    width: 240px;
    padding-right: 10px;
    border-right: 1px solid #eee;

    &_no-border {
      border-right: none;
      padding-right: 0;
      width: 100%;
    }
  }

  &__acts {
    padding-left: 10px;
  }

  &__textarea {
    max-width: 100%;
    min-width: 100%;
    max-height: 100px;
  }
}

.device-info-header {
  &__icon {
    margin-right: 5px;
    width: 22px;
    height: 22px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}


.acts-table {
  .vs-table--tbody {
    border: none;
  }

  .vs-table--content {
    padding: 0;
  }

  .vs-table--thead {
    tr {
      background-color: #f4f4f4;
    }
  }

  .vs-table--tbody-table .tr-values td {
    position: relative;
    padding: 10px 15px;
  }

  .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
    padding: 15px;
  }

  &__show-all {
    text-transform: uppercase;
    font-size: 0.75rem;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      color: rgba(var(--vs-primary), 1);
      text-decoration: underline;
    }
  }

  &__value {
    font-size: 13px;
    /*white-space:;*/
    line-height: 1.2;

    & + & {
      margin-top: 10px;
    }
  }

  &__value-small {
    font-size: 11px;
    color: gray;
  }

  &__status {
    width: 250px;
    border-radius: 0;
  }

  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .tr-values.vs-table--tr {
    &:nth-child(2n+1) {
      background: #f6f6f6;
    }
  }
}

.scroll-table {
  display: block;
  flex: 1;

  &__wrapper {
    overflow: hidden;
  }

}

</style>
